import { useEffect } from 'react';
import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LINK_ID = 'explora-custom-css';

// CSS site-block keys that feed the app-wide global stylesheet (footer + CMS
// global). Tag-description CSS is loaded separately (only on tag pages).
const GLOBAL_CSS_KEYS = [
  'footer_below_left_css',
  'footer_below_right_css',
  'pages_global_css',
  'pages_global_css_mobile',
  'modules_global_css',
  'main_custom_css',
  'main_custom_css_mobile',
];

export const TAGS_CSS_KEYS = ['tags_description_css', 'tags_description_css_mobile'];

// Tiny stable string hash (djb2) → short hex. Used only for cache-busting.
export const hashString = (str) => {
  let h = 5381;
  for (let i = 0; i < str.length; i += 1) {
    h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
  }
  return h.toString(16);
};

export const cssVersion = (blocks, keys) =>
  hashString(keys.map((k) => blocks?.[k] || '').join('|'));

// Create/update a versioned <link rel="stylesheet"> in <head> by id.
export const setCssLink = (id, href) => {
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }
  if (link.getAttribute('href') !== href) link.setAttribute('href', href);
};

export const removeCssLink = (id) => {
  const link = document.getElementById(id);
  if (link && link.parentNode) link.parentNode.removeChild(link);
};

/**
 * Injects the site-wide admin-defined CSS as a single external <link> stylesheet
 * (replacing the old inline <style> injections). The `?v=` hash is derived from
 * the same source content, so updating CSS in the admin instantly busts the cache.
 */
const CustomCss = () => {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/site-blocks`);
        if (cancelled) return;
        const version = cssVersion(data, GLOBAL_CSS_KEYS);
        setCssLink(LINK_ID, `${API_BASE}/custom-css.css?v=${version}`);
      } catch (_) { /* non-fatal: site renders without custom CSS */ }
    })();
    return () => { cancelled = true; };
  }, []);

  return null;
};

export default CustomCss;
